<template>
	<component :is="tag" :style="style"><sym-icon name="trash"></sym-icon></component>
</template>

<script setup lang="ts">
import type {DataColumn} from "@t/fd/layout/Agenda.ts";
import {type CSSProperties, computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = withDefaults(defineProps<{
	col: DataColumn,
	tag?: string
}>(), { tag: "th" });
const style = computed<CSSProperties>(() => {
	if (props.tag === "th") return { textAlign: "center" };
	return {}
});
</script>


<style>

</style>
